<app-select [searchable]="true" [class.no-min-width]="isMobile()" [alignLeft]="true"
  [disabled]="!rule().displayOptions.active || disabled()" [(ngModel)]="rule().itemType"
  (selectedValueChange)="itemTypeChanged()">
  <app-option [value]="'All'" [text]="'All'" [imgSet]="[imgPrefix + currencyImage, imgPrefix + armourImage, imgPrefix + weaponImage]" [alt]="'Currency'" [width]="'16px'" [height]="'16px'">
  </app-option>
  <app-option [value]="'All Gear'" [text]="'All Gear'" [imgSet]="[imgPrefix + armourImage, imgPrefix + weaponImage]" [alt]="'Armour'" [width]="'16px'" [height]="'16px'">
  </app-option>
  <app-option [value]="'All Weapons'" [text]="'All Weapons'" [imgUrl]="imgPrefix + weaponImage" [alt]="'Weapon'" [width]="'16px'" [height]="'16px'">
  </app-option>
  <app-option [value]="'All Armour'" [text]="'All Armour'" [imgUrl]="imgPrefix + armourImage" [alt]="'Armour'" [width]="'16px'" [height]="'16px'">
  </app-option>
  @if (poe2) {
    <app-option [value]="'All Augments'" [text]="'All Augments'" [imgUrl]="imgPrefix + augmentsImage" [alt]="'Augment'" [width]="'16px'" [height]="'16px'">
    </app-option>
    <app-option [value]="'All Runes'" [text]="'All Runes'" [imgUrl]="imgPrefix + runesImage" [alt]="'Rune'" [width]="'16px'" [height]="'16px'">
    </app-option>
    <app-option [value]="'All Gems'" [text]="'All Gems'" [imgUrl]="imgPrefix + gemsImage" [alt]="'Gem'" [width]="'16px'" [height]="'16px'">
    </app-option>
    <app-option [value]="'All Uncut Gems'" [text]="'All Uncut Gems'" [imgUrl]="imgPrefix + uncutGemsImage" [alt]="'Uncut Gem'" [width]="'16px'" [height]="'16px'">
    </app-option>
  }
  @for (itemType of itemData; track itemType.itemType) {
    <app-option [value]="itemType.itemType" [text]="itemType.itemType" [imgUrl]="imgPrefix + itemType.baseTypes[0].image" [alt]="itemType.itemType" [width]="'16px'" [height]="'16px'">
    </app-option>
  }
</app-select>
<span class="sep"></span>
<app-autocomplete
  [options]="baseTypeAutocompleteOptions()"
  [disabled]="!rule().displayOptions.active || disabled() || !!metaTypeInfo()"
  [disabledPlaceholder]="metaTypeInfo()"
  [showOptions]="rule().itemClass !== 'All' && !rule().itemType.includes('All')"
  [selectedValues]="rule().baseTypes"
  (selectedValuesChange)="baseTypesChanged($event)"
  [showTooltip]="false"
  ></app-autocomplete>
